import React from 'react';
import Mathcca1to22024 from 'views/Mathcca1to22024';
const MathClubPage = () => {
  return <Mathcca1to22024/>;
};

export default MathClubPage;

